export const howHelpListing = [
	{
		icon: '👩‍💻',
		title: 'howHelpData_title1',
		subtitle: 'howHelpData_subtitle1',
	},
	{
		icon: '🎨',
		title: 'howHelpData_title2',
		subtitle: 'howHelpData_subtitle2',
	},
	{
		icon: '🖼',
		title: 'howHelpData_title3',
		subtitle: 'howHelpData_subtitle3',
	},
	{
		icon: '☝️',
		title: 'howHelpData_title4',
		subtitle: 'howHelpData_subtitle4',
	},
	{
		icon: '✨',
		title: 'howHelpData_title5',
		subtitle: 'howHelpData_subtitle5',
	},
];
